import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import type { Article } from '../types/showcase';
interface ArticleCardProps {
  article: Article;
  layout?: 'stack' | 'row';
}
export function ArticleCard({
  article,
  layout = 'stack'
}: ArticleCardProps) {
  const isRow = layout === 'row';
  return <article className="group h-full" data-id="element-16" data-mp="19zpkghmvbwo1">
      <a href={article.url} target="_blank" rel="noreferrer" className={`flex h-full rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-4 ${isRow ? 'flex-col gap-6 md:flex-row md:items-center md:gap-10' : 'flex-col'}`} data-id="element-17" data-mp="19ynyvj887rs2">
        <div className={`overflow-hidden rounded-xl bg-canvas ${isRow ? 'aspect-[16/10] md:w-1/2 md:shrink-0' : 'aspect-[16/10]'}`} data-id="element-18" data-mp="r0bndqtue5tb">
          <img src={article.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" loading="lazy" data-id="element-19" data-mp="2qbuwc5f5be2z" />
        </div>
        <div className={`flex flex-1 flex-col ${isRow ? '' : 'pt-5'}`} data-id="element-20" data-mp="30f6sfjqtbqx">
          <p className="text-sm text-muted" data-id="element-21" data-mp="71hbhbwfig0a">{article.date}</p>
          <h3 className={`mt-2 font-semibold leading-snug text-ink group-hover:text-navy ${isRow ? 'text-2xl md:text-3xl' : 'text-xl'}`} data-id="element-22" data-mp="3p62cjdthr9i8">
            {article.title}
          </h3>
          <p className="mt-3 line-clamp-3 leading-relaxed text-muted" data-id="element-23" data-mp="lou2hg509dy2">{article.excerpt}</p>
          <span className="mt-auto inline-flex items-center gap-1 pt-4 text-sm font-semibold text-orange-deep" data-id="element-24" data-mp="qnx5yw5c7c3x">
            Read article
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="bzshfbjls6d8" />
          </span>
        </div>
      </a>
    </article>;
}